import { Shape } from '@/services/shape';
import { TextWatchfaceAttribute } from '@/services/shape/attributes/text-watchface';
import { toRgb } from '@/watch-renderer/utils/color';
import {
  addResourceIfNotExists,
  generateLayoutAst
} from '../utils/resource.utils';

export const getTextWatchfaceAst = (resourceAst: Ast, shape: Shape) => {
  const attrs = shape.attrs as TextWatchfaceAttribute;
  const {
    rotation,
    fontId = 'misans',
    fontSize,
    fontWeight = 'normal',
    color = '#ffffff',
    style,
    align,
    letterSpace,
    w = 0,
    h = 0,
    texts,
    textType,
    literalTextLength = 0,
    longMode = 'clip',
    lineSpace = 0,
    currentTextIndex = 0,
    customFontFile = '',
    customFontCropFile = '',
    _visibility = true,
    recolorEnable = false
  } = attrs;
  const refAst: Ast = {
    tag: 'DataItemText',
    attrsMap: {
      w: String(w),
      h: String(h),
      rotation: rotation + '',
      fontId: fontId.toLowerCase(),
      fontSize: String(fontSize),
      fontWeight: fontWeight.toLowerCase(),
      color: toRgb(color),
      style: style,
      align: align ?? 'left',
      letterSpace: String(letterSpace),
      string: texts.join('\0'),
      literal_num: texts.length.toString(),
      literal_string_length: literalTextLength.toString(),
      longMode,
      lineSpace: String(lineSpace),
      literal_font: '',
      literal_crop_font: '',
      _type: 'watchface'
    },
    children: []
  };

  // 重着色标记：当开启重着色时，APP 端根据此标记对文字应用配色
  if (recolorEnable) {
    refAst.attrsMap.recolorEnable = 'true';
  }
  // 是否使用自定义字体
  if (shape.usingCustomFont) {
    if (customFontFile) {
      const fileAst: Ast = addResourceIfNotExists(
        resourceAst,
        {
          tag: 'File',
          attrsMap: {
            name: customFontCropFile.split('.')?.[0],
            fileName: customFontCropFile,
            format: 'ttf'
          },
          children: []
        },
        undefined,
        true
      );
      refAst.attrsMap.fontId = customFontFile.split('.')?.[0];
      refAst.attrsMap.fontWeight = 'normal';
      refAst.attrsMap.literal_font = customFontFile;
      refAst.attrsMap.literal_crop_font = `@${fileAst.attrsMap.name}`;
    } else {
      refAst.attrsMap.fontId = 'misans';
      refAst.attrsMap.fontWeight = 'normal';
    }
  }
  refAst.attrsMap.string = texts.map((item) => item || ' ').join('\\0');
  refAst.attrsMap._string = `${toRgb(color)} ${
    texts[currentTextIndex] || ' '
  }#`;

  if (textType === 'dateWeek') {
    refAst.children.push({
      tag: 'Content',
      attrsMap: {
        source: 'dateWeek'
      },
      children: []
    });
  }

  const ast = addResourceIfNotExists(resourceAst, refAst);
  // 生成 layout ast
  const layoutAst: Ast = generateLayoutAst({
    ref: '@' + ast.attrsMap.name,
    x: attrs.x,
    y: attrs.y
  });
  layoutAst.attrsMap._id = shape.id;
  layoutAst.attrsMap._hidden = String(_visibility ? 'false' : 'true');
  return layoutAst;
};
